import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../../modules/jobFunctions/jobFinancialSummaryActions'
import * as api from '../../api/job/financialSummary'

function* getJobFinancialSummary(action) {
  try {
    const payload = yield call(api.getJobFinancialSummary, action.jobId)
    yield put({ type: constants.GET_FINANCIAL_SUMMARY.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_FINANCIAL_SUMMARY.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetJobFinancialSummary() {
  yield takeLatest(constants.GET_FINANCIAL_SUMMARY.ACTION, getJobFinancialSummary)
}

function* sagaUpdateJobFinancialSummary(action) {
  try {
    const payload = {
      job_id: action.jobId,
      content: action.content,
      updated_by_id: action.userId,
      user_id: 1
    }
    yield call(api.updateJobFinancialSummary, payload)
    yield put({ type: constants.FINANCIAL_SUMMARY_UPDATE.SUCCESS, payload })
    yield call(getJobFinancialSummary, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.FINANCIAL_SUMMARY_UPDATE.FAILED,
      message: e.message || e
    })
  }
}

function* watchUpdateScheduleDrawing() {
  yield takeLatest(constants.FINANCIAL_SUMMARY_UPDATE.ACTION, sagaUpdateJobFinancialSummary)
}

/**
 * Export the root saga by forking all available sagas.
 */
export function* rootSaga() {
  // add more sagas here
  yield all([fork(watchGetJobFinancialSummary), fork(watchUpdateScheduleDrawing)])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/jobFunctions/jobFinancialSummarySaga.js